export type SpeedDestinationSession = {
  north?: {
    county?: string | null;
    city?: string | null;
    state?: string | null;
    postcode?: string | null;
  };
  south?: {
    county?: string | null;
    city?: string | null;
    state?: string | null;
    postcode?: string | null;
  };
};

const STORAGE_KEY = "speed_destination_session_v1";

export function saveSpeedDestinationSession(setting?: any): SpeedDestinationSession | null {
  if (!setting) return null;

  const payload: SpeedDestinationSession = {
    north: {
      county: setting.speed_destination_county_north ?? null,
      city: setting.speed_destination_city_north ?? null,
      state: setting.speed_destination_state_north ?? null,
      postcode: setting.speed_destination_postcode_north ?? null,
    },
    south: {
      county: setting.speed_destination_county_south ?? null,
      city: setting.speed_destination_city_south ?? null,
      state: setting.speed_destination_state_south ?? null,
      postcode: setting.speed_destination_postcode_south ?? null,
    },
  };

  try {
    const raw = JSON.stringify(payload);
    sessionStorage.setItem(STORAGE_KEY, raw);
    localStorage.setItem(STORAGE_KEY, raw);
  } catch {
    // ignore
  }

  return payload;
}

export function getSpeedDestinationSession(): SpeedDestinationSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SpeedDestinationSession;
  } catch {
    return null;
  }
}

export function clearSpeedDestinationSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}


